import { ChevronDown, Medal } from 'lucide-react';
import { useEffect, useState } from 'react';
import { api } from '../api.js';
import MobileShell, { BrandFooter } from '../components/MobileShell.jsx';

export default function LeaderboardPage() {
  const [config, setConfig] = useState(null);
  const [scope, setScope] = useState('school');
  const [organization, setOrganization] = useState(() => {
    try { return JSON.parse(localStorage.getItem('quizProfile') || '{}').organization || ''; } catch { return ''; }
  });
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { api('/api/config').then((data) => { setConfig(data); if (!organization) setOrganization(data.colleges[0]); }); }, [organization]);
  useEffect(() => {
    if (scope === 'college' && !organization) return;
    setLoading(true);
    api(`/api/leaderboard?scope=${scope}&organization=${encodeURIComponent(organization)}`).then((data) => setRows(data.rows)).finally(() => setLoading(false));
  }, [scope, organization]);

  const top = rows.slice(0, 3);
  return (
    <MobileShell className="leaderboard-page" showBack backTo="/">
      <img className="rank-icon" src="/assets/7.png" alt="" />
      <div className="rank-tabs">
        <button className={scope === 'school' ? 'active' : ''} onClick={() => setScope('school')}>全校</button>
        <button className={scope === 'college' ? 'active' : ''} onClick={() => setScope('college')}>学院</button>
      </div>
      <section className="rank-card">
        <header><span>RANKING</span><h1>竞赛排行榜</h1></header>
        {scope === 'college' && (
          <label className="rank-select"><select value={organization} onChange={(event) => setOrganization(event.target.value)}>{config?.colleges.map((college) => <option key={college}>{college}</option>)}</select><ChevronDown size={17} /></label>
        )}
        {!loading && top.length > 0 && (
          <div className="podium">
            {[top[1], top[0], top[2]].map((row, index) => row ? (
              <div className={`podium-person place-${row.rank}`} key={row.rank}>
                <div className="podium-avatar">{row.name.slice(0, 1)}<span>{row.rank}</span></div>
                <b>{row.name}</b><small>{row.score} 分</small>
              </div>
            ) : <div key={index} />)}
          </div>
        )}
        <div className="rank-list">
          {loading ? <div className="rank-empty">正在载入排名…</div> : rows.length === 0 ? <div className="rank-empty"><Medal size={32} />还没有成绩，完成答题后成为首位上榜者。</div> : rows.map((row) => (
            <div className="rank-row" key={`${row.rank}-${row.className}-${row.name}`}>
              <span className={`rank-number rank-${row.rank}`}>{row.rank}</span>
              <div className="rank-person"><b>{row.name}</b><small>{row.className} · {row.organization}</small></div>
              <div className="rank-score"><b>{row.score}</b><span>{(row.durationMs / 1000).toFixed(1)}s</span></div>
            </div>
          ))}
        </div>
      </section>
      <BrandFooter />
    </MobileShell>
  );
}
